import React from 'react';
import { Container, Paper, Toolbar, Box } from '@mui/material';
import { Routes, Route, Outlet, useParams } from 'react-router-dom';
import PriceLists from './pricelists';
import PriceList from './pricelist';
import { PriceListCreate } from './pricelist';
import PriceSelector from './selector';
import { PriceSelectorCreate } from './selector';
import Import from './import';

/**
 * Price module router component that handles nested routes for pricelists, selectors, and import.
 */
export default function PriceIndex() {
  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route index element={<PriceLists />} />
              <Route path="import" element={<Import />} />
              <Route
                path="pricelists/:priceListId/selectors/_create"
                Component={() => <PriceSelectorCreate priceListId={parseInt(useParams().priceListId!)} />}
              />
              <Route
                path="pricelists/:priceListId/selectors/:id"
                Component={() => <PriceSelector priceListId={parseInt(useParams().priceListId!)} id={parseInt(useParams().id!)} />}
              />
              <Route path="pricelists/_create" Component={() => <PriceListCreate />} />
              <Route path="pricelists/:id" Component={() => <PriceList id={parseInt(useParams().id!)} />} />
              <Route path="pricelists" Component={() => <PriceLists />} />
            </Routes>

            <Outlet />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
